// import Footer from "../components/Footer";
import Header from '../components/Header';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { AppDispatch, RootState } from '../store/store';
import { useEffect, useState } from 'react';
import {
  copyPurchaseCart,
  fetchLandmarkThunk,
  fetchPurchaseCart,
  fetchStoreThunk,
  resetCheckoutResponse,
  webStorefrontCheckoutAsync,
} from '../store/purchaseSlice';
import {
  CartLineItems,
  CheckoutFeedback,
  OrderDetails,
  PaymentMethod,
  PaymentSocketResponse,
  PurchaseItem,
  StoreInterface,
} from '../interfaces';
import { convertSecondsToMinutesAndSeconds, formatCurrency } from '../utils';
import AuthService from '../services/authService';
import {
  HubConnection,
  HubConnectionBuilder,
  LogLevel,
} from '@microsoft/signalr';
import Popup from '../components/Popup';
import SpinnerIcon from '/asset/infinite-spinner.svg';
import SuccessIcon from '/asset/CheckCircle.svg';
import CancelIcon from '/asset/cancel.svg';
import { fetchUserInfo } from '../store/authSlice';
import EmptyCart from '../components/EmptyCart';
import CartResponseCard from '../components/CartResponseCard';
import Cart from '../components/Cart';
import whatsAppIcon from '/asset/whatsApp.svg';
import { closeFrame, openFrame } from '../utils/iframeModal';
import Content from '../components/Content';
import BackNavBar from '../components/BackNavBar';
import KeyValueList from '../components/KeyValueList';
import WigetBox from '../components/WigetBox';
import CheckoutFormAlt from '../components/CheckoutFormAlt';
import StackIcon from '/asset/Stack.svg';
import ArrorRightIcon from '/asset/ArrowRight.svg';
import { toast } from 'react-toastify';
import { setLoginFrom } from '../store/setupSlice';
import FinancingOptionsModal from '../components/FinancingOptionsModal';
const BASE_URL = import.meta.env.VITE_BASEURL as string;

export default function Checkout() {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const phoneRegex = /^\+234\d{10}$/;
  const [payonWeb, setPayonWeb] = useState<boolean>(false);
  const [showBnplDetails, setShowBnplDetails] = useState<boolean>(false);
  const { loading } = useSelector((state: RootState) => state.purchase);
  const { purchase: purchaseData, miscellanousFeeName } = useSelector(
    (state: RootState) => state.purchase
  );
  const { storeInfo } = useSelector((state: RootState) => state.products);

  const user = useSelector((state: RootState) => state.auth.user);
  const { checkoutResponse } = useSelector(
    (state: RootState) => state.purchase
  );
  const { storeId, routesPrefix, guestSessionId, companyId } = useSelector(
    (state: RootState) => state.setup
  );
  const [store, setStore] = useState<StoreInterface | null>(null);
  const [checkoutFeedback, setCheckoutFeedback] =
    useState<CheckoutFeedback | null>(null);
  const { stores } = useSelector((state: RootState) => state.products);

  const bnplLink = import.meta.env.VITE_BNPL_URL as string;
  const [cart, setCart] = useState<PurchaseItem[]>([]);
  const [selectedPaymentMethod, setSelectedPaymentMethod] =
    useState<PaymentMethod | null>(null);
  const [continuePayNow, setContinuePayNow] = useState<boolean>(false);
  const [cartLineItems, setCartLineItems] = useState<CartLineItems[]>([]);
  const auth_token = useSelector((state: RootState) => state.auth.token);
  const dispatch = useDispatch<AppDispatch>();

  const navigate = useNavigate();
  const goToWhatsApp = () => {
    const whatsAppNumber = storeInfo?.mimicWhatsAppPhoneNumber;

    if (!whatsAppNumber) {
      // no number configured
      console.warn('WhatsApp number not configured');
      return;
    }
    // Build message listing all items and their quantities
    let message = `Hello, I would like to complete my order.%0A%0A`; // %0A = newline for URL
    message += `Purchase Code: ${purchaseData?.purchaseCode}`;

    // Normalize phone number and open WhatsApp chat
    const normalizedNumber = whatsAppNumber.replace(/\D/g, '');
    const waUrl = `https://wa.me/${normalizedNumber}?text=${message}`;
    window.open(waUrl, '_blank');
  };

  const [orderDetails, setOrderDetails] = useState<OrderDetails>({
    reference: '',
    orderType: 0,
    orderAddress: '',
    deliveryInstructions: '',
    emailAddress: '',
    phoneNumber: '',
    deliveryLocationId: 0,
    firstName: '',
    lastName: '',

    deliveryAddress: '',
    country: '',
    city: '',
    line1: '',
    line2: '',
    landmark: '',
    zipCode: '',
    area: '',
    state: '',
    long: 0,
    lat: 0,
  });

  const [orderDetailsValid] = useState<OrderDetails>({
    reference: '',
    orderType: '',
    orderAddress: '',
    deliveryLocationId: 0,
    phoneNumber: '',
    deliveryInstructions: '',
    emailAddress: '',
    firstName: '',
    lastName: '',

    deliveryAddress: '',
    country: '',
    city: '',
    line1: '',
    line2: '',
    landmark: '',
    zipCode: '',
    area: '',
    state: '',
    long: 0,
    lat: 0,
  });

  const [validOrderDetails, setValidOrderDetails] = useState(false);
  const [total, setTotal] = useState<number>(0);
  useEffect(() => {
    let t = 0;
    for (let i = 0; i < cart.length; i++) {
      t += (cart[i].quantity ?? 0) * (cart[i].unitPrice || 0);
    }
    setTotal(t);
  }, [cart]);

  useEffect(() => {
    dispatch(fetchStoreThunk());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const ci: CartLineItems[] = [];
    cart.map((thisCartItem) => {
      ci.push({
        quantity: thisCartItem.quantity,
        productVariantId: thisCartItem.productVariantId,
        specialRequest: thisCartItem.specialRequest,
      });
    });
    setCartLineItems(ci);
  }, [cart]);

  useEffect(() => {
    const oD = { ...orderDetailsValid };
    setValidOrderDetails(false);

    if (
      orderDetails.emailAddress &&
      emailRegex.test(orderDetails.emailAddress)
    ) {
      oD.emailAddress = '';
    } else {
      oD.emailAddress = 'Invalid Email Address';
    }

    if (orderDetails.phoneNumber && phoneRegex.test(orderDetails.phoneNumber)) {
      oD.phoneNumber = '';
    } else {
      oD.phoneNumber = 'Invalid Phone Number';
    }

    if (orderDetails.firstName && orderDetails.firstName.trim() !== '') {
      oD.firstName = '';
    } else {
      oD.firstName = 'First Name is required';
    }

    if (orderDetails.lastName && orderDetails.lastName.trim() !== '') {
      oD.lastName = '';
    } else {
      oD.lastName = 'Last Name is required';
    }

    if (orderDetails.orderType === 1) {
      if (orderDetails.orderAddress.length > 5) {
        oD.orderAddress = '';
      } else {
        oD.orderAddress = 'Order Address Invalid';
      }
      if (orderDetails.deliveryLocationId === 0) {
        oD.deliveryLocationId = null;
      } else {
        oD.deliveryLocationId = 0;
      }
    } else {
      oD.orderAddress = '';
    }

    const requireLocationId =
      store?.selfFulfilmentDeliveryProviderOptions.deliveryMode ===
        'LocationGroups' &&
      store?.deliveryOptions.deliveryProvider === 'SelfFulfilment';

    let v =
      ((!user && oD.emailAddress === '' && oD.phoneNumber === '') || user) &&
      ((orderDetails.orderType === 1 &&
        (orderDetails.line1 === '' || orderDetails.line2 === '')) ||
        Number(orderDetails.orderType) === 0) &&
      ((!user && oD.firstName === '' && oD.lastName === '') || !!user);

    if (requireLocationId && Number(orderDetails.orderType) === 1) {
      v = v && orderDetails.deliveryLocationId !== 0;
    }

    setValidOrderDetails(v || false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderDetails, user]);

  useEffect(() => {
    dispatch(resetCheckoutResponse());
    dispatch(fetchLandmarkThunk());
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchUserInfo());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (auth_token) {
      dispatch(fetchPurchaseCart());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth_token]);

  useEffect(() => {
    if (purchaseData) {
      if (purchaseData.purchases) {
        setCart(purchaseData.purchases);
      }
    }
  }, [purchaseData]);

  // const tokenCountdown = 90
  const waitTime = 900;
  const [count, setCount] = useState<number>(0);

  const [openModal, setOpenModal] = useState<boolean>(false);
  const [showLoginModal, setShowLoginModal] = useState<boolean>(false);
  const [showBnplProceedModal, setShowBnplProceedModal] =
    useState<boolean>(false);
  const [showDelayedOrderModal, setShowDelayedOrderModal] =
    useState<boolean>(false);
  const [listening, setListening] = useState<boolean>(false);
  const accessToken = AuthService.getAccessToken();
  const [listeningResponse, setListeningResponse] =
    useState<PaymentSocketResponse | null>(null);
  const [connection, setConnection] = useState<HubConnection | undefined>(
    undefined
  );
  const [paymentMode, setPaymentMode] = useState<0 | 1>(0);
  const [bnplUrl, setBnplUrl] = useState<string>('');
  const [bnplText, setBnplText] = useState<string>('Pay Small Small');
  const [selectedBnplShortCode, setSelectedBnplShortCode] =
    useState<string>('');
  const [pendingBnplOpen, setPendingBnplOpen] = useState<boolean>(false);
  const [bnplDropdownOpen, setBnplDropdownOpen] = useState<boolean>(false);
  const [searchParams] = useSearchParams();
  const checkoutParam = searchParams.get('checkout');

  useEffect(() => {
    if (checkoutParam === 'bnpl') {
      setPayonWeb(true);
      setBnplDropdownOpen(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const endConnection = () => {
    if (connection) {
      connection.stop();
      setListening(false);
    }
  };

  useEffect(() => {
    let timer: NodeJS.Timeout;

    if (count > 0) {
      timer = setTimeout(() => {
        setCount((prev) => prev - 1);
      }, 1000);
    }

    return () => clearTimeout(timer);
  }, [count]);

  useEffect(() => {
    setCount(checkoutResponse ? waitTime : 0);
  }, [checkoutResponse]);

  useEffect(() => {
    if (listeningResponse !== null) {
      if (
        listeningResponse.orderStatus?.toLowerCase().includes('success') ||
        listeningResponse.paymentStatus?.toLowerCase().includes('paid')
      ) {
        if (
          listeningResponse.paymentOption &&
          listeningResponse.paymentOption == 1
        ) {
          closeFrame();
        }
        setOpenModal(true);
        dispatch(fetchPurchaseCart());

        const timer = setTimeout(() => {
          navigate(`${routesPrefix}receipt/${checkoutResponse?.purchaseCode}`);
        }, 5000); // 1 minute

        return () => clearTimeout(timer);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listeningResponse]);

  useEffect(() => {
    if (accessToken && listening && user) {
      const connection = new HubConnectionBuilder()
        .withUrl(`${BASE_URL}StoreHub`, {
          accessTokenFactory: () => accessToken, // Add the access token to the headers
        })
        .configureLogging(LogLevel.Information)
        .build();

      connection.on('OrderPaymentConfirmation', (payment) => {
        setListeningResponse(payment);
      });

      connection
        .start()
        .then(() => {
          console.log('SignalR connection established');
        })
        .catch((err) => {
          console.error('Error establishing SignalR connection:', err);
        });

      // Store the connection
      setConnection(connection);

      // Cleanup function
      return () => {
        connection
          .stop()
          .catch((err) =>
            console.error('Error stopping SignalR connection:', err)
          );
      };
    }
  }, [accessToken, listening, user]);

  useEffect(() => {
    if (storeId && stores) {
      const selectedStore = stores.find((store) => store.id === storeId);
      if (selectedStore) {
        setStore(selectedStore);
      }
    }
  }, [stores, storeId]);

  useEffect(() => {
    if (
      storeInfo &&
      (!storeInfo.mimicWhatsAppPhoneNumber || !storeInfo.isMimicEnabled)
    ) {
      setPayonWeb(true);
    }
  }, [storeInfo]);

  useEffect(() => {
    if (
      !pendingBnplOpen ||
      !checkoutFeedback ||
      !selectedBnplShortCode ||
      !user?.phoneNumber
    ) {
      return;
    }

    const emailParam = user.email
      ? `&email=${encodeURIComponent(user.email)}`
      : '';
    const firstNameParam = user.firstName
      ? `&firstName=${encodeURIComponent(user.firstName)}`
      : '';
    const lastNameParam = user.lastName
      ? `&lastName=${encodeURIComponent(user.lastName)}`
      : '';
    const merchantCodeParam = selectedPaymentMethod?.bnplMerchantCode
      ? `&merchantCode=${encodeURIComponent(selectedPaymentMethod.bnplMerchantCode)}`
      : '';

    const bnplCheckoutUrl =
      bnplLink +
      `${selectedBnplShortCode}?amount=${checkoutFeedback.totalAmountWithVAT}&purchaseCode=${checkoutFeedback.purchaseCode}&phoneNumber=${encodeURIComponent(user.phoneNumber)}${emailParam}${firstNameParam}${lastNameParam}${merchantCodeParam}`;

    setBnplUrl(bnplCheckoutUrl);
    setShowBnplProceedModal(true);
    setPendingBnplOpen(false);
    setContinuePayNow(false);
  }, [
    bnplLink,
    checkoutFeedback,
    pendingBnplOpen,
    selectedBnplShortCode,
    selectedPaymentMethod?.bnplMerchantCode,
    user?.phoneNumber,
    user?.email,
    user?.firstName,
    user?.lastName,
  ]);

  const handleBnplProceedModalClose = () => {
    setShowBnplProceedModal(false);
    if (bnplUrl) {
      openFrame(bnplUrl);
    }
  };

  const isWithinStoreHours = (): boolean => {
    if (!storeInfo?.openingTime || !storeInfo?.closingTime) return true;
    const now = new Date();
    const openDate = new Date(storeInfo.openingTime);
    const closeDate = new Date(storeInfo.closingTime);
    // Get local hours/minutes from the parsed dates
    const openLocalMinutes = openDate.getHours() * 60 + openDate.getMinutes();
    const closeLocalMinutes =
      closeDate.getHours() * 60 + closeDate.getMinutes();
    const currentMinutes = now.getHours() * 60 + now.getMinutes();

    if (closeLocalMinutes > openLocalMinutes) {
      return (
        currentMinutes >= openLocalMinutes &&
        currentMinutes <= closeLocalMinutes
      );
    }
    // Overnight range (e.g., 22:00 - 06:00)
    return (
      currentMinutes >= openLocalMinutes || currentMinutes <= closeLocalMinutes
    );
  };

  const handlePayNowClick = () => {
    if (!isWithinStoreHours()) {
      setShowDelayedOrderModal(true);
    } else {
      setContinuePayNow(!continuePayNow);
    }
  };

  useEffect(() => {
    if (!storeInfo?.mimicWhatsAppPhoneNumber || !storeInfo?.isMimicEnabled) {
      setPayonWeb(true);
    }
  }, [storeInfo]);

  const selectBnplOption = (paymentMethod: PaymentMethod) => {
    if (paymentMethod && user) {
      const BNPLTEXT =
        paymentMethod?.checkoutButtonText &&
        paymentMethod?.checkoutButtonText !== ''
          ? paymentMethod?.checkoutButtonText
          : 'Pay Small Small ';
      setBnplText(BNPLTEXT);
      setPaymentMode(1);
      setSelectedPaymentMethod(paymentMethod);
      setSelectedBnplShortCode(paymentMethod?.bnplShortCode);
      if (checkoutFeedback) {
        const feedback = checkoutFeedback;
        const bnplShortCode = paymentMethod?.bnplShortCode;
        const emailParam = user.email
          ? `&email=${encodeURIComponent(user.email)}`
          : '';
        const firstNameParam = user.firstName
          ? `&firstName=${encodeURIComponent(user.firstName)}`
          : '';
        const lastNameParam = user.lastName
          ? `&lastName=${encodeURIComponent(user.lastName)}`
          : '';

        const bnplCheckoutUrl =
          bnplLink +
          `${bnplShortCode}?amount=${feedback.totalAmountWithVAT}&purchaseCode=${feedback.purchaseCode}&phoneNumber=${user.phoneNumber}${emailParam}${firstNameParam}${lastNameParam}`;
        setBnplUrl(bnplCheckoutUrl);
        setShowBnplProceedModal(true);
      } else {
        setPendingBnplOpen(true);
        handlePayNowClick();
      }
    } else {
      setShowLoginModal(true);
    }
  };

  const renderBnplOption = (paymentMethod: PaymentMethod, index: number) => {
    const BNPLTEXT =
      paymentMethod?.checkoutButtonText &&
      paymentMethod?.checkoutButtonText !== ''
        ? paymentMethod?.checkoutButtonText
        : `Pay Small Small (${index + 1})`;
    return (
      <div
        key={`paymentmethod-${index}`}
        role="button"
        tabIndex={0}
        aria-label={`Select ${paymentMethod?.name}`}
        className={`
          w-full flex items-center gap-[14px]
        border
        border-primary-200
        hover:!bg-blue-50
        hover:border-secondary-400
        rounded-md
        px-[16px] py-[14px] cursor-pointer
        transition-colors`}
        style={{
          background: paymentMethod?.checkoutButtonSecondaryColour
            ? `${paymentMethod?.checkoutButtonSecondaryColour}20`
            : undefined,
        }}
        onClick={() => {
          console.log('Selected BNPL Option:', paymentMethod);
          // setBnplDropdownOpen(false);
          selectBnplOption(paymentMethod);
        }}
        // onKeyDown={(e) => {
        //   if (e.key === 'Enter' || e.key === ' ') {
        //     e.preventDefault();
        //     setBnplDropdownOpen(false);
        //     selectBnplOption(paymentMethod);
        //   }
        // }}
      >
        <div
          className={`flex-shrink-0 w-[36px] h-[36px] flex items-center justify-center
          `}
        >
          {paymentMethod?.logoUrl ? (
            <img
              src={paymentMethod.logoUrl}
              alt={paymentMethod?.name}
              className="w-[28px] h-[28px] object-contain"
              onError={(e) => {
                e.currentTarget.style.display = 'none';
                e.currentTarget.nextElementSibling?.classList.remove('hidden');
              }}
            />
          ) : null}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 30 30"
            fill="none"
            stroke={paymentMethod?.checkoutButtonPrimaryColour || '#2563eb'}
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={`w-[28px] h-[28px] ${paymentMethod?.logoUrl ? 'hidden' : ''}`}
          >
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z" />
            <path d="M12 6v6l4 2" />
          </svg>
        </div>
        <div className="flex-1 min-w-0">
          <p
            className="text-[14px] font-semibold leading-tight"
            style={{
              color: paymentMethod?.checkoutButtonPrimaryColour || '#2563eb',
            }}
          >
            {BNPLTEXT}
          </p>
          <p className="text-[12px] text-gray-500 mt-[2px]">
            {paymentMethod?.name}
          </p>
        </div>
      </div>
    );
  };

  return (
    <div className="w-100 flex flex-col min-h-screen">
      <Popup
        isOpen={openModal}
        popUpClass="!max-w-[400px] !w-[90%] !rounded-2xl"
        onClose={() => {
          if (user) {
            navigate(`${routesPrefix}history`);
          } else {
            navigate(`${routesPrefix}`);
          }
          setOpenModal(false);
        }}
      >
        <div className="p-[10px]">
          <img
            src={SuccessIcon}
            className="m-auto w-[40px] mt-[20px]
          "
          />
          <h2
            className="text-2xl font-bold text-center 
              mt-1 font-dmsans text-gray-900
              text-[16px]"
          >
            Payment Successful!
          </h2>
          <p
            className="text-gray-600 font-dmsans
          text-center text-[10px]"
          >
            Your order has been confirmed
          </p>
          <div className="flex justify-center gap-[10px] mt-4 text-[11px]">
            <div className="text-gray-900">Total Paid:</div>
            <div className="text-secondary-500">
              {formatCurrency(Number(checkoutResponse?.totalAmountWithVAT))}
            </div>
          </div>
          <div
            className="flex flex-col justify-center items-center
          gap-[2px] mt-[10px] text-[12px]
          bg-secondary-100 max-w-[200px] m-auto
          p-[15px] rounded-md border-secondary-500 border-[1px] border-solid
          "
          >
            <div className="text-[8px] text-gray-900">Order Reference:</div>
            <div className="text-secondary-500">
              {checkoutResponse?.purchaseCode}
            </div>
          </div>
          <div className="flex justify-center mt-[20px]">
            <div
              className="
            border-[1px] border-secondary-500 rounded-sm
            text-secondary-500 font-bold text-[10px]
            p-[5px] flex place-center items-center gap-[5px] cursor-pointer
            "
              onClick={() => {
                setOpenModal(false);
                navigate(
                  `${routesPrefix}receipt/${checkoutResponse?.purchaseCode}`
                );
              }}
            >
              <img src={StackIcon} className="h-[15px] w-[15px]" />
              <div>Back to store</div>
            </div>
            <div
              className="bg-secondary-500 text-white font-bold text-[10px]
            p-[5px] cursor-pointer rounded-sm
            flex place-center items-center gap-[5px] ml-[10px]"
              onClick={() => {
                navigate(
                  `${routesPrefix}receipt/${checkoutResponse?.purchaseCode}`
                );
              }}
            >
              <div>View Invoice</div>
              <img src={ArrorRightIcon} className="h-[15px] w-[15px]" />
            </div>
          </div>
        </div>
      </Popup>
      <Popup
        isOpen={showDelayedOrderModal}
        onClose={() => setShowDelayedOrderModal(false)}
      >
        <div className="p-[20px]">
          <h2 className="text-xl text-black font-bold text-center mt-4 font-dmsans">
            Store is Currently Closed
          </h2>
          <p className="text-gray-600 mt-2 font-dmsans text-center">
            This store is not open at the moment. Your order may be delayed.
            Would you like to proceed anyway?
          </p>
          <div className="flex justify-center gap-4 mt-[30px]">
            <div
              className="text-center font-bold uppercase bg-black font-dmsans text-white px-6 py-2 rounded-full cursor-pointer"
              onClick={() => {
                setShowDelayedOrderModal(false);
                setContinuePayNow(!continuePayNow);
              }}
            >
              Proceed
            </div>
            <div
              className="text-center font-bold uppercase bg-gray-300 font-dmsans text-black px-6 py-2 rounded-full cursor-pointer"
              onClick={() => setShowDelayedOrderModal(false)}
            >
              Cancel
            </div>
          </div>
        </div>
      </Popup>
      <Popup isOpen={showLoginModal} onClose={() => setShowLoginModal(false)}>
        <div className="p-[20px]">
          <h2 className="text-xl text-black font-bold text-center mt-4 font-dmsans">
            Login Required
          </h2>
          <p className="text-gray-600 mt-2 font-dmsans text-center">
            Login required to use this payment option
          </p>
          <div className="flex justify-center gap-4 mt-[30px]">
            <div
              className="text-center font-bold uppercase bg-black font-dmsans text-white px-6 py-2 rounded-full cursor-pointer"
              onClick={() => {
                setShowLoginModal(false);
                dispatch(setLoginFrom('bnplcheckout'));
                navigate(`${routesPrefix}auth`);
              }}
            >
              Login
            </div>
            <div
              className="text-center font-bold uppercase bg-gray-300 font-dmsans text-black px-6 py-2 rounded-full cursor-pointer"
              onClick={() => setShowLoginModal(false)}
            >
              Cancel
            </div>
          </div>
        </div>
      </Popup>
      <FinancingOptionsModal
        isOpen={showBnplDetails}
        showEcsOffer={companyId === Number(import.meta.env.VITE_ECS_ID)}
        onClose={() => {
          setBnplDropdownOpen((prev) => !prev);
          setShowBnplDetails(false);
        }}
        companyId={companyId}
      />
      <Popup
        isOpen={showBnplProceedModal}
        onClose={handleBnplProceedModalClose}
      >
        <div className="p-[20px]">
          <h2 className="text-xl text-black font-bold text-center mt-4 font-dmsans">
            Order Received
          </h2>
          <p className="text-gray-600 mt-2 font-dmsans text-center">
            Please complete the PaySmallSmall process before your order can be
            processed
          </p>
          <div className="flex justify-center mt-[30px]">
            <div
              className="text-center font-bold uppercase bg-black font-dmsans text-white px-6 py-2 rounded-full cursor-pointer"
              onClick={handleBnplProceedModalClose}
            >
              Proceed
            </div>
          </div>
        </div>
      </Popup>
      <Header loginFrom="checkout" />
      <div className="flex flex-col flex-1">
        {checkoutResponse === null && (
          <BackNavBar
            label={payonWeb ? 'Back to Payment Options' : 'Back to Storefront'}
            onClick={() => {
              if (payonWeb) {
                setPayonWeb(false);
                setContinuePayNow(false);
              } else {
                navigate(`${routesPrefix}`);
              }
            }}
          />
        )}

        <Content
          className="flex gap-[20px]
          w-full h-auto
          bg-white content-center justify-center
          flex-col-reverse lg:flex-row
          px-[5%] lg:px-0 thin-light-scrollbar
          pt-[20px] pb-[250px]
          "
        >
          {checkoutResponse !== null ||
            (cart && cart.length > 0 && (
              <div>
                {!continuePayNow && !payonWeb && (
                  <div>
                    {/* Payment Options */}
                    <WigetBox
                      extraClassName="
                  bg-white flex flex-col gap-[14px] mb-[20px]"
                    >
                      <p className="text-[15px] font-semibold text-gray-800 mb-[4px]">
                        Checkout options
                      </p>

                      {/* Pay on web */}
                      {!storeInfo?.isStorefrontMimicOnlyModeEnabled && (
                        <div
                          className="w-full flex items-center gap-[14px]
                          bg-blue-50 border border-secondary-200 
                          rounded-md px-[16px] py-[14px] cursor-pointer
                          hover:bg-blue-100 transition-colors
                          hover:border-secondary-500"
                          onClick={() => {
                            setPayonWeb(true);
                          }}
                        >
                          <div className="flex-shrink-0 pt-1 w-[36px] h-[36px] flex items-center justify-center">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 30 30"
                              fill="none"
                              stroke="#2563eb"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="w-[28px] h-[28px]"
                            >
                              <rect
                                x="1"
                                y="4"
                                width="22"
                                height="16"
                                rx="2"
                                ry="2"
                              />
                              <line x1="1" y1="10" x2="23" y2="10" />
                            </svg>
                          </div>
                          <div className="flex-1 min-w-0">
                            <p className="text-[14px] font-semibold text-blue-600 leading-tight">
                              Checkout Online
                            </p>
                          </div>
                        </div>
                      )}

                      {/* CONTINUE ON WHATSAPP */}
                      {storeInfo?.mimicWhatsAppPhoneNumber &&
                        storeInfo?.isMimicEnabled && (
                          <div
                            className="w-full flex items-center gap-[14px]
                          bg-blue-50 border border-secondary-200 
                          rounded-md px-[16px] py-[14px] cursor-pointer
                          hover:bg-blue-100 transition-colors
                          hover:border-secondary-500"
                            onClick={goToWhatsApp}
                          >
                            <div className="flex-shrink-0 w-[36px] h-[36px] flex items-center justify-center">
                              <img
                                src={whatsAppIcon}
                                alt="whatsapp"
                                className="w-[28px] h-[28px]"
                              />
                            </div>
                            <div className="flex-1 min-w-0">
                              <p className="text-[14px] font-semibold text-blue-600 leading-tight">
                                Continue on Whatsapp
                              </p>
                            </div>
                          </div>
                        )}
                    </WigetBox>
                  </div>
                )}
                {!continuePayNow && payonWeb && (
                  <div>
                    {/* Payment Options */}
                    <WigetBox
                      extraClassName="
                  bg-white flex flex-col gap-[14px] mb-[20px]"
                    >
                      <p className="text-[15px] font-semibold text-gray-800 mb-[4px]">
                        Payment Method
                      </p>

                      {/* PAY WITH Transfer */}
                      {!storeInfo?.isStorefrontMimicOnlyModeEnabled && (
                        <div
                          className="w-full flex items-center gap-[14px]
                          bg-gray-50 border 
                          border-primary-200 
                          hover:bg-blue-50 
                          hover:border-secondary-400
                          rounded-md
                          px-[16px] py-[14px] cursor-pointer
                          transition-colors"
                          onClick={() => {
                            setPendingBnplOpen(false);
                            setPaymentMode(0);
                            handlePayNowClick();
                          }}
                        >
                          <div className="flex-shrink-0 w-[36px] h-[36px] flex items-center justify-center">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 30 30"
                              fill="none"
                              stroke="#2563eb"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="w-[28px] h-[28px]"
                            >
                              <rect
                                x="1"
                                y="4"
                                width="22"
                                height="16"
                                rx="2"
                                ry="2"
                              />
                              <line x1="1" y1="10" x2="23" y2="10" />
                            </svg>
                          </div>
                          <div className="flex-1 min-w-0">
                            <p className="text-[14px] font-semibold text-blue-600 leading-tight">
                              Pay with Bank Transfer
                            </p>
                            <p className="text-[12px] text-gray-500 mt-[2px]">
                              Transfer payment to unique account details
                            </p>
                          </div>
                        </div>
                      )}

                      {/* PAYSMALLSMALL PAYMENT OPTIONS */}
                      {storeInfo &&
                        storeInfo.paymentMethods &&
                        storeInfo.paymentMethods.length > 0 &&
                        (!storeInfo.isStorefrontLoginDisabled || user) && (
                          <>
                            {storeInfo.paymentMethods.length > 1 ? (
                              <div className="relative">
                                <div
                                  role="button"
                                  tabIndex={0}
                                  aria-haspopup="listbox"
                                  aria-expanded={bnplDropdownOpen}
                                  className="w-full flex items-center gap-[14px]
                            border
                            border-primary-200
                            hover:!bg-blue-50
                            hover:border-secondary-400
                            rounded-md
                            px-[16px] py-[14px] cursor-pointer
                            transition-colors
                            focus:outline-none focus-visible:ring-2 focus-visible:ring-secondary-400"
                                  onClick={() => {
                                    if (!bnplDropdownOpen) {
                                      setShowBnplDetails(true);
                                    } else {
                                      setBnplDropdownOpen((prev) => !prev);
                                    }
                                  }}
                                  onKeyDown={(e) => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                      e.preventDefault();
                                      if (!bnplDropdownOpen) {
                                        // setShowBnplDetails(true);
                                        setBnplDropdownOpen((prev) => !prev);
                                      } else {
                                        setBnplDropdownOpen((prev) => !prev);
                                      }
                                    }
                                  }}
                                >
                                  <div className="flex-shrink-0 w-[36px] h-[36px] flex items-center justify-center">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      viewBox="0 0 30 30"
                                      fill="none"
                                      stroke="#2563eb"
                                      strokeWidth="1.8"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="w-[28px] h-[28px]"
                                    >
                                      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z" />
                                      <path d="M12 6v6l4 2" />
                                    </svg>
                                  </div>
                                  <div className="flex-1 min-w-0">
                                    <p className="text-[14px] font-semibold text-blue-600 leading-tight">
                                      Pay Small Small
                                    </p>
                                    <p className="text-[12px] text-gray-500 mt-[2px]">
                                      Choose a Pay Small Small option
                                    </p>
                                  </div>
                                  <div className="flex-shrink-0 w-[20px] h-[20px] flex items-center justify-center">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="#6b7280"
                                      strokeWidth={2}
                                      className={`w-[18px] h-[18px] transition-transform duration-200 ${
                                        bnplDropdownOpen ? 'rotate-180' : ''
                                      }`}
                                    >
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M19 9l-7 7-7-7"
                                      />
                                    </svg>
                                  </div>
                                </div>

                                {bnplDropdownOpen && (
                                  <div className="flex flex-col gap-[10px] mt-[10px]">
                                    {storeInfo.paymentMethods.map(
                                      (paymentMethod, index) =>
                                        renderBnplOption(paymentMethod, index)
                                    )}
                                  </div>
                                )}
                              </div>
                            ) : (
                              renderBnplOption(storeInfo.paymentMethods[0], 0)
                            )}
                          </>
                        )}
                    </WigetBox>
                  </div>
                )}
              </div>
            ))}

          {continuePayNow && (
            <div>
              <WigetBox
                extraClassName="
                  !border-none !p-0 mt-[0px] mb-[20px] md:mb-[40px]"
              >
                {checkoutResponse === null && (
                  <div className="w-full">
                    <CheckoutFormAlt
                      orderDetails={orderDetails}
                      setOrderDetails={setOrderDetails}
                      orderDetailsValid={orderDetailsValid}
                    />
                    <div
                      className={`w-full h-[50px] w-full leading-[50px] rounded-md
                                        text-center font-dmsans font-regular text-[12px] cursor-pointer font-bold
                                        ${
                                          validOrderDetails
                                            ? 'bg-secondary-500 text-white'
                                            : 'bg-gray-200 text-gray-300'
                                        }`}
                      onClick={() => {
                        if (!loading && validOrderDetails) {
                          dispatch(
                            copyPurchaseCart({
                              cartLineItems,
                              orderDetails,
                            })
                          );
                          dispatch(
                            webStorefrontCheckoutAsync({
                              guestSessionId: String(guestSessionId),
                              purchaseCode: purchaseData?.purchaseCode,
                              emailAddress: String(orderDetails?.emailAddress),
                              firstName: String(orderDetails?.firstName),
                              lastName: String(orderDetails?.lastName),
                              orderType: Number(orderDetails?.orderType),
                              deliveryAddress: orderDetails?.orderAddress || '',
                              paymentMode: paymentMode,
                              deliveryLocationId:
                                orderDetails?.deliveryLocationId || null,
                              deliveryInstructions:
                                orderDetails.deliveryInstructions || '',
                              address: {
                                line1: orderDetails?.line1 || '',
                                line2: orderDetails?.line2 || '',
                                city: orderDetails?.city || '',
                                state: orderDetails?.state || '',
                                area: orderDetails?.area || '',
                                country: orderDetails?.country || '',
                                latitude: orderDetails?.lat || 0,
                                longitude: orderDetails?.long || 0,
                                landmark: orderDetails?.landmark || '',
                              },
                            })
                          ).then((res) => {
                            if (
                              webStorefrontCheckoutAsync.fulfilled.match(res)
                            ) {
                              const payload = res.payload as {
                                data?: CheckoutFeedback;
                              };
                              setCheckoutFeedback(payload?.data ?? null);
                            }
                            dispatch(fetchPurchaseCart());
                            if (user) {
                              setListening(true);
                            }
                          });
                        } else if (!validOrderDetails) {
                          toast.error('Fill all required fields');
                        }
                      }}
                    >
                      {loading
                        ? '...Loading'
                        : `Proceed ${paymentMode === 1 ? 'to ' + bnplText : ''}`}
                    </div>
                  </div>
                )}

                {checkoutResponse !== null && (
                  <div className=" mt-[20px] font-dmsans">
                    <div>
                      <CartResponseCard
                        cartResponse={checkoutResponse}
                        setListeningResponse={setListeningResponse}
                        endConnection={endConnection}
                        bnplUrl={bnplUrl}
                        paymentMode={paymentMode}
                        bnplText={bnplText}
                      />
                      {paymentMode === 0 && (
                        <div>
                          {listeningResponse === null && (
                            <>
                              <div className="flex gap-[20px] my-[20px] justify-center content-center">
                                <img src={SpinnerIcon} className="w-[20px]" />
                                <div className="text-[10px] text-gray-500">
                                  Waiting to receive the payment
                                </div>
                              </div>

                              <div className="font-dmsans text-[14px] text-center my-[20px]">
                                Expires in
                                <span className="font-bold ml-[5px] text-green-500">
                                  {convertSecondsToMinutesAndSeconds(count)}
                                </span>
                              </div>
                            </>
                          )}

                          {listeningResponse !== null && (
                            <div className="flex gap-[20px]">
                              <img
                                src={
                                  listeningResponse.paymentStatus
                                    ?.toLowerCase()
                                    .includes('paid') ||
                                  listeningResponse.orderStatus
                                    ?.toLowerCase()
                                    .includes('success')
                                    ? SuccessIcon
                                    : CancelIcon
                                }
                                className="w-[20px]"
                              />
                              <div
                                className={`text5 font-bold font-dmsans
                                              ${
                                                listeningResponse.paymentStatus
                                                  ?.toLowerCase()
                                                  .includes('paid') ||
                                                listeningResponse.orderStatus
                                                  ?.toLowerCase()
                                                  .includes('success')
                                                  ? 'text-green-500'
                                                  : 'text-red-500'
                                              }
                                              `}
                              >
                                {listeningResponse.paymentStatus
                                  ?.toLowerCase()
                                  .includes('paid') ||
                                listeningResponse.orderStatus
                                  ?.toLowerCase()
                                  .includes('success')
                                  ? 'Payment Received Successfully, Redirecting to order history'
                                  : 'Error receiving payment'}
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </WigetBox>
            </div>
          )}

          <div>
            {((cart && cart.length === 0) || cart === null) &&
              !continuePayNow && (
                <WigetBox
                  extraClassName="mb-[20px] m-auto
                  md:mb-[40px] !w-[350px] bg-white"
                >
                  <EmptyCart />
                </WigetBox>
              )}
            {cart && cart.length > 0 && (
              <div>
                <WigetBox
                  extraClassName="mb-[20px] 
                  lg:mb-[40px] lg:w-[350px] bg-white"
                >
                  <Cart cart={cart} />
                  <div className="text-[14px] mt-[20px]">
                    <KeyValueList
                      title="Sub-total"
                      value={total}
                      isCurrency={true}
                    />
                    <KeyValueList
                      title="VAT"
                      value={purchaseData?.vat ?? 0}
                      isCurrency={true}
                    />
                    <KeyValueList
                      title="Consumption Fee"
                      value={purchaseData?.consumptionFee ?? 0}
                      isCurrency={true}
                    />
                    <KeyValueList
                      title={miscellanousFeeName || 'Miscellanous Fee'}
                      value={purchaseData?.miscellaneousFee ?? 0}
                      isCurrency={true}
                    />
                    <div
                      className="border-t-[1px] border-secondary-50 
                      border-solid w-full h-[1px]"
                    ></div>
                    <KeyValueList
                      title="Total"
                      value={purchaseData?.totalAmountWithVAT ?? 0}
                      isCurrency={true}
                    />
                  </div>
                </WigetBox>
              </div>
            )}
          </div>
        </Content>
      </div>
    </div>
  );
}
